<div *ngIf="seatType && seatsStatusAndTitle && seatsStatusAndTitle.length > 0">
  <div *ngIf="isDark">
    <div [ngStyle]="{'width' : width + '%','opacity' : (isSelectable ? (item.isSelected ? '1' : '0.2' ) : '1'),  'color' :(selectedSeats.indexOf(item.key) > -1 ? '#FFFFFF' : '#173D0E'),  'background-color': (selectedSeats.indexOf(item.key) > -1 ? ('#173D0E') : (item.isSelected ? '#ECFFD2' : '#FADFD1'))}" class="seat_single en" *ngFor="let item of seatsStatusAndTitle" (click)="onAction(1,item.key)" title="{{item.value}}">
      <span>{{item.value}}</span>
    </div>
  </div>
  <div *ngIf="!isDark">
    <div [ngStyle]="{'width' : width + '%','opacity': item.isSelected ? '1' : '0.4'}" class="seat_single en" *ngFor="let item of seatsStatusAndTitle" title="{{item.value}}">
      <span>{{item.value}}</span>
    </div>
  </div>  
</div>
